import styled from "styled-components";

export const FeaturedChallengesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;
  padding-bottom: 64px;

  > h1 {
    color: ${({ theme }) => theme.colors.neutralsText};
    text-align: center;
    font-family: Roboto;
    font-size: 36px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    letter-spacing: -0.36px;
    margin-bottom: 42px;
  }

  > div:nth-child(2) {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 48px;
    width: 100%;

    > div {
      flex-basis: calc((100% - 32px) / 3);
      min-height: 200px;
      margin: 0;
      padding: 0;
      max-width: 490px;

      ${({ theme }) => theme.media.onlyTablet`
        flex-basis: calc((100% - 16px) / 2);
        justify-content: center;
      `}
      ${({ theme }) => theme.media.onlySmallDesktop`
        flex-basis: calc((100% - 16px) / 2);
        justify-content: center;
      `}
    }
    ${({ theme }) => theme.media.onlyMobile`
      flex-direction: column;
      gap: 0;
      > div {
        min-height: 150px;
      }
    `}
  }

  > div:last-child {
    display: flex;
    justify-content: space-between;
    gap: 17px;
  }
`;
